import { render, staticRenderFns } from "./HereToHelpKicker.vue?vue&type=template&id=71e8a283"
import script from "./HereToHelpKicker.vue?vue&type=script&lang=js"
export * from "./HereToHelpKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports